import React from 'react';

import MFormDatetimeView from './MFormDatetime.view';

interface Props {
  className?: string;
  value: moment.Moment | null;
  name: string;
  placeholder?: string;
  showTimeSelect?: boolean;
  showTimeSelectOnly?: boolean;
  timeIntervals?: number;
  timeCaption?: string;
  dateFormat?: string;
  minDate?: moment.Moment | null;
  maxDate?: moment.Moment | null;
  disabled?: boolean;
  weekDays?: number[];
  holidays?: moment.Moment[];
  onChange: (prop: moment.Moment | null) => void;
}

const MFormDatetime: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MFormDatetimeView
      className={props.className}
      value={props.value}
      name={props.name}
      placeholder={props.placeholder}
      showTimeSelect={props.showTimeSelect}
      showTimeSelectOnly={props.showTimeSelectOnly}
      timeIntervals={props.timeIntervals}
      timeCaption={props.timeCaption}
      dateFormat={props.dateFormat}
      minDate={props.minDate}
      maxDate={props.maxDate}
      disabled={props.disabled}
      onChange={props.onChange}
      weekDays={props.weekDays}
      holidays={props.holidays}
    >
      {props.children}
    </MFormDatetimeView>
  );
};

MFormDatetime.displayName = 'MFormDatetime';
MFormDatetime.defaultProps = {};

export default MFormDatetime;
